// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3uhbS","col":"styles_col__1AQtD"};